import { TextEditor } from '@approvalmax/ui';
import styled from 'styled-components';

export const TextEditorStyled = styled(TextEditor)`
    text-align: right;
`;
